<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import UserForm from '@/components/users/UserForm.vue';
    import { RoleOption } from '@/types';
    import { useI18n } from 'vue-i18n';
    import QueryKey from '@/enums/QueryKey';

    const { t } = useI18n();

    const form = useForm({
        name: '',
        email: '',
        phone: '',
        role_ids: [],
        company_ids: [],
        contact_persons: [],
        language: 'da',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.users.store')"
        :query-key="[QueryKey.USERS]"
        title="users.create_txt"
        button-text="users.create_txt"
        modal-size="sm:max-w-xl"
        :success-message-translated="t('users.create.success', { username: form.name })"
        :transform="
            (data) => ({
                ...data,
                role_ids: data.role_ids.map((role: RoleOption) => `${role.company_id}_${role.id}`),
            })
        "
    >
        <UserForm :form="form" />
    </DialogForm>
</template>
